import { FIRM_CODENAMES_SMALL } from '../../constants'
import { ListController } from '../../controllers/list-controller.class'

class ZaysController extends ListController {
  ALLOW_DELETE_MSG = 'Вы уверены, что хотите удалить заявку?'
  ONLY_AUTHOR_CAN_DELETE = 'Заявку может удалить только ее автор.'

  constructor($scope, $injector, popup, zayModal, zaysServiceApiV2, toaster) {
    super($scope, $injector)
    this.popup = popup
    this.modal = zayModal
    this.api = zaysServiceApiV2
    this.toaster = toaster
    this.tableOptions = {
      headers: {
        hid: '№',
        type_alias: 'По&nbsp;фирме',
        data: 'Дата',
        plid__comp: 'Плательщик',
        pergruz: 'Груз',
        autor__fio: 'Автор (менеджер)',
      },
      tablesorterOptions: {
        sortList: [[0, 1]],
        headers: {
          0: { sorter: 'zay/hid' },
        },
      },
    }
  }

  $onInit() {
    this.modalLocals = {
      ourFirms: this.ourFirms,
      legacyUsers: this.legacyUsers,
      managers: this.managers,
      contracts: this.contracts,
      inner: false,
      parentData: null,
      selected: this.selected,
    }
    super.$onInit()
  }

  rowFormatter(row) {
    row.type_alias = FIRM_CODENAMES_SMALL[row.type]
    return row
  }

  get defaultFilters() {
    return {
      hid__icontains: null, // номер заявки
      plid_comp: null, // плательщик
      kmbm: null, // по фирме
    }
  }

  finansy() {
    return this.popup.state(
      'zay.base.finansy',
      { id: this.selected },
      1024,
      768
    )
  }

  editNewWin() {
    this.popup.state('zay.base.detail', { id: this.selected }, 1024, 768)
  }

  addZay() {
    this.modalLocals.inner = false
    this.modalLocals.parentData = null
    this.modalLocals.selected = this.selected
    super.add()
  }

  addInner() {
    this.modalLocals.inner = true
    this.modalLocals.parentData = this.selectedData
    this.modalLocals.selected = this.selected
    super.add()
  }
}

export const ZaysComponent = {
  template: require('./zays.component.html'),
  styles: [require('./zays.component.scss')],
  bindings: {
    ourFirms: '<',
    legacyUsers: '<',
    managers: '<',
  },
  controller: ZaysController,
  controllerAs: 'vm',
}
